import React, { useState, useEffect } from 'react';

const LoadingSpinner = () => {
  const [currentJokeIndex, setCurrentJokeIndex] = useState(0);

  const jokes = [
    "Why did the Empath bring a ruler to the game? To measure the evil in their neighbors!",
    "The Investigator walks into a bar with the Scarlet Woman and the Imp. The bartender says, \"What is this, a bluff?\"",
    "The Fortune Teller tells the Storyteller, \"I see a 'yes' in your future... or a 'no'. Definitely one of those.\"",
    "A Virgin, a Slayer, and a Drunk walk into town. The Virgin says, \"Don't nominate me!\" The Slayer says, \"I'll kill the Demon!\" The Drunk says, \"Wait, what's my name again?\"",
    "Why did the Chef get confused? Because the Storyteller kept showing him fingers, and he just wanted to cook.",
    "The Monk protected the Soldier. The Imp attacked. The Monk sighs, \"Well, at least someone's still alive.\"",
    "The Poisoner offers the Ravenkeeper a drink. The Ravenkeeper says, \"Is this the one where I get information after I die?\"",
    "The Undertaker spends all day looking at dead bodies. At night, they dream of alive ones.",
    "The Washerwoman asks the Librarian, \"So, which one of us is actually reading the rulebook?\"",
    "The Saint gets executed. Everyone loses. The Storyteller says, \"Well, that was efficient.\"",
    "The Spy knows everything. The Drunk knows nothing. They make a surprisingly good pair for misinformation.",
    "Why was the Baron always inviting extra people? He just loved a crowded table, especially if they were Outsiders.",
    "The Gambler tried to bet on who the Demon was. The Storyteller just shook their head.",
    "The Dreamer picks a player. The Storyteller shows two tokens. The Dreamer sighs, \"So, still 50/50 then.\"",
    "The Exorcist tried to banish the Imp. The Imp just laughed and killed someone else.",
    "The Chambermaid cleans up after everyone, but still doesn't know who woke up last night.",
    "The Courtier made the Imp Drunk. Now the Imp is just rambling about how much they love the good team.",
    "The Clockmaker knows the distance, but not the direction. It's like a compass that only tells you the radius.",
    "The Minstrel sings a song. Everyone is safe. The Demon is furious.",
    "The Mutant just wanted to blend in, but every time they got nominated, things got weird.",
    "The Pukka offered to swap roles. The Savant said, \"Half of that information is false, so I'm not sure if I'd be alive anyway.\"",
    "The Juggler juggled bluffs. The Storyteller just hoped they didn't drop any.",
    "The Artist asked, \"Is the Storyteller lying?\" The Storyteller replied, \"I don't know.\"",
    "The Professor brought someone back to life. They immediately asked, \"Who killed me?\"",
    "The Grandmother knows too much. The Imp wished she'd just bake cookies.",
    "The Goon just wants to hit things. Preferably the Demon.",
    "The Godfather is so good at bluffs, even the Minions aren't sure who they're working for sometimes.",
    "The Bard sings of heroes. The Drunk thinks the song is about them.",
    "The Philosopher gained the Slayer's ability. Now they're having an existential crisis about who to kill.",
    "The Sweetheart died. Someone immediately got Drunk. \"Well, that's rude,\" said the Storyteller.",
    "The Witch cursed a player. They nominated someone. Poof Dead. The Witch shrugged.",
    "The Cannibal ate a dead player. Now they're feeling a bit guilty and gassy.",
    "The Pixie floats around, spreading misinformation by accident. \"Oops, did I say that out loud?\"",
    "The Assassin says, \"I know who the Demon is.\" Everyone holds their breath.",
    "The Alchemist tried to brew a potion to reveal the Demon. It just turned everyone blue.",
    "The Lycanthrope howled at the moon. The Storyteller just marked them as a normal player.",
    "The Seamstress tries to mend the fabric of lies, but it's a losing battle.",
    "The Balloonist takes everyone for a ride, sometimes literally.",
    "The Heretic just wants to watch the world burn. Or at least, the town.",
    "The Poppygrower cultivates flowers. The Demon cultivates chaos. They're both busy.",
    "The Goblin always gets executed. It's just their lot in life.",
    "The Marionette pulls the strings. The players just dance.",
    "The Sage only gets information when they die. \"So, I guess I'll just wait for that then,\" they say.",
    "The Oracle sees the future, but it's always blurry around the Demon.",
    "The Bounty Hunter wants to find the Demon. The Demon wants to find the Bounty Hunter first.",
    "The Professor resurrected the Drunk. The Drunk immediately forgot they were resurrected.",
    "The Minion looks at the Imp. The Imp looks at the Minion. They both know it's time for some chaos.",
    "The Storyteller smiles. Everyone shivers.",
    "The Good team wins! The Evil team sighs. \"Next time, Gadget, next time.\""
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentJokeIndex(Math.floor(Math.random() * jokes.length));
    }, 20000); // Change joke every 20 seconds

    return () => clearInterval(interval);
  }, [jokes.length]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto"></div>
        <p className="mt-4 text-gray-600 dark:text-gray-300">Loading...</p>
        <p className="mt-2 text-sm text-gray-500 dark:text-gray-400 max-w-xs mx-auto">
          If this is your first visit in a while, the server may be starting up due to inactivity. This can take up to 30 seconds. Please do not refresh—just wait for the app to load.
        </p>
        <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg max-w-md mx-auto">
          <p className="text-sm text-blue-800 dark:text-blue-200 italic">
            "{jokes[currentJokeIndex]}"
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner; 